import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-job-card',
  templateUrl: './job-card.component.html',
  styleUrl: './job-card.component.scss'
})
export class JobCardComponent {
  @Input() job: any;
  @Input() currency: any;
  @Output() apply = new EventEmitter<any>();
  @Output() save = new EventEmitter<any>();
  @Output() unsave = new EventEmitter<any>();

  applyToJob() {
    this.apply.emit(this.job);
  }

  toggleSave() {
    if (this.job.saved_job) {
      this.unsave.emit(this.job);
    } else {
      this.save.emit(this.job);
    }
  }
}
